import type { AxiosInstance } from "axios";
import { apiClient } from "@/data/axiosConfig";

export interface AddressAutocompleteResult {
  placeId: string;
  text: string;
}

export interface AddressLookupResult {
  formattedAddress: string;
  streetNumber: string;
  premise: string;
  route: string;
  subpremise: string;
  postalCode: string;
  postalTown: string;
  postBox: string;
  adminArea1: string;
  adminArea2: string;
  country: string;
  countryIso2: string;
}

export interface AddressSearchRequest {
  query: string;
  countries?: string[];
  location?: {
    latitude: number;
    longitude: number;
  };
  sessionToken?: string;
}

export interface AddressSearchResponse {
  results: AddressAutocompleteResult[];
}

export interface AddressPlaceDetailsRequest {
  placeId: string;
  sessionToken?: string;
}

export interface AddressPlaceDetailsResponse {
  result: AddressLookupResult;
}

export function createAddressApi(client: AxiosInstance) {
  return {
    search: async (request: AddressSearchRequest): Promise<AddressSearchResponse> => {
      const response = await client.post<AddressSearchResponse>("/api/addresses/search", request);
      return response.data;
    },
    getDetails: async (request: AddressPlaceDetailsRequest): Promise<AddressPlaceDetailsResponse> => {
      const response = await client.post<AddressPlaceDetailsResponse>("/api/addresses/details", request);
      return response.data;
    },
  };
}

export const addressApi = createAddressApi(apiClient);

